// Splits Contentful "notes" (semicolon-delimited) into list items.
// Trailing/duplicate semicolons in CMS produce empty segments — those are removed.
export const convertContentfulNotesFromString = (string) => {
  if (string === undefined) {
    return;
  }
  return string
    .split(";")
    .map((note) => note.trim())
    .filter((note) => note.length > 0);
};
